<template>
  <Modal
    class="scoped"
    :modal-style="{ maxWidth: '900px' }"
    title="Social Report Preview"
  >
    <div class="card q-pa-md column no-wrap full-height iframe-container">
      <QSpinner
        v-show="loading"
        class="full-width q-mt-lg"
        :size="30"
      />
      <iframe
        ref="iframe"
        class="report-preview scroll-y"
      />
    </div>
  </Modal>
</template>

<script>
import Modal from "shared/components/core/modals/Modal.vue";

export default {
  name: "SocialReportPreviewModal",
  components: {
    Modal,
  },
  props: {
    report: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      reportHtml: "",
      loading: false,
    };
  },
  mounted() {
    this.loadPreviewData();
  },
  methods: {
    async loadPreviewData() {
      try {
        this.loading = true;

        const response = await this.$streemApiAdmin.post(
          "social_reports/preview",
          {
            params: {
              ...this.report,
            },
          }
        );

        this.reportHtml = response.data;
      } catch {
        this.$q.notify({
          message: "Could not create preview",
          color: "error",
        });
      } finally {
        this.loading = false;
        this.fillIFrame();
      }
    },
    fillIFrame() {
      const iframeDocument = this.$refs.iframe.contentWindow.document;
      iframeDocument.open();
      iframeDocument.write('<base target="_blank">');
      iframeDocument.write(this.reportHtml);

      iframeDocument.write(
        '<style type="text/css"> body { width: 100%; } </style>'
      );

      iframeDocument.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.iframe-container {
  position: relative;
  overflow: hidden;
}

.report-preview {
  position: absolute;
  inset: 60px 0 0;
  height: 100%;
  width: 100%;
  padding: 0 5px 20px 0;
  border: none;
}
</style>
